import type { SVGProps } from "react";
const SvgLoupe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 19 19"
    {...props}
  >
    <path
      fill="#F0BB44"
      fillRule="evenodd"
      d="M0 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m1.477 0A6.53 6.53 0 0 0 8 14.523 6.53 6.53 0 0 0 14.523 8 6.53 6.53 0 0 0 8 1.477 6.53 6.53 0 0 0 1.477 8"
      clipRule="evenodd"
    />
    <path
      fill="#F0BB44"
      d="m18.773 17.676-4.449-4.449a.776.776 0 1 0-1.097 1.097l4.449 4.449a.773.773 0 0 0 1.097 0 .776.776 0 0 0 0-1.097"
    />
  </svg>
);
export default SvgLoupe;
